module.exports = __webpack_public_path__ + "media/images/img_mail-6bb7a4dc6ce350ba97a28976b759d9d2.png";